import dataFeatureKey from './modules/dataFeatureKey'

export const setupDirective = (vueApp) => {
  vueApp.directive('featureKey', dataFeatureKey)
}
